import { render } from "./Renew.vue?vue&type=template&id=83ad1816&scoped=true"
import script from "./Renew.vue?vue&type=script&lang=js"
export * from "./Renew.vue?vue&type=script&lang=js"

import "./Renew.vue?vue&type=style&index=0&id=83ad1816&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83ad1816"]])

export default __exports__